module.exports = __webpack_public_path__ + "static/Neue-Haas-Grotesk-Display-55-b0732c883fd7c8cea9d7b87a94eb936b.woff";